export enum EnumTpMovimentacaoEstoque {
   CorrigirSaldo = 1,
   Entrada = 2,
   Saida = 3
}